import React, { useState, useEffect, useRef } from "react";
import { Typography, Paper } from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import { makeStyles } from "@material-ui/core/styles";
import LocalAtmIcon from '@material-ui/icons/LocalAtm';
import AddCircleOutlineIcon from "@material-ui/icons/AddCircleOutline";
// import ArrowCircleLeft from "@material-ui/icons/ArrowCircleLeft";
import { Link, Redirect, withRouter, useLocation } from 'react-router-dom';
import EditIcon from "@material-ui/icons/Edit";
import SwapHorizIcon from '@material-ui/icons/SwapHoriz';
import CloseIcon from "@material-ui/icons/Close";
import BiztranControls from "../../biztran_controls/BiztranControls";
import TextField from '../../biztran_controls/Input';
import ModalFrame from "../../biztran_controls/Modal_Frame";
import CreateQuotation from "./CreateQuotation";
import AlertDialog from "../../biztran_controls/AlertDialog";
import UseFetchData from "../../../hooks/UseFetchData";
import axios from 'axios';
import Moment from "moment";
import { REPORT_URL } from "../../../Global";
import SendEmail from "../MessageCenter/SendEmail"
import CloseQut from "./CloseQut";
import moment from "moment";
import { date } from "yup";
import { useHistory } from 'react-router-dom';
import Session from "react-session-api";
import { PinDropSharp } from "@material-ui/icons";



const HeaderView = ({ QuotationMainData, QuotationID, PopulateData, ProductCount }) => {
  //debugger;
  const classes = useStyles();
  const [isOpen, setOpen] = useState(false);
  const [isMailOpen, setMailOpen] = useState(false);
  const [Mode, setMode] = useState('');
  const [AccountID, setAccountID] = useState('');
  const [QuotationLostReasonCodeID, setQuotationLostReasonCodeID] = useState('');
  const [Count, setCount] = useState(0);
  const [RevNo, setRevNo] = useState(0);
  const [Num, setNum] = useState(0);
  const [QTID, SetQTID] = useState('');
  const [viewPath, setViewPath] = useState('https://pmcrm.rpt.biztran.in/WebService.asmx/PrintReport');
  const [viewPaths, setViewPaths] = useState('');
  const [DisableAddbtn, setDisableAddbtn] = useState(false);
  const [QuotationNo, setQuotationNo] = useState("");
  const [Company, setCompany] = useState("");
  const [QuotationDate, setQuotationDate] = useState('');
  const [Lead, setLead] = useState("");
  const [Opportunity, setOpportunity] = useState("");
  const [AccountName, setAccountName] = useState("");
  const [HandledBy, setHandledBy] = useState("");
  const [GeneratedBy, setGeneratedBy] = useState("");
  const [ValidUpToDate, setValidUpToDate] = useState("");
  const [QuotationLostRemarks, setQuotationLostRemarks] = useState("");
  const [QuotationLostWonBy, setQuotationLostWonBy] = useState("");
  const [QuotationLostUpdatedByID, setQuotationLostUpdatedByID] = useState("");
  const [QuotationLostUpdatedOn, setQuotationLostUpdatedOn] = useState("");
  const [PredictedClosingDate, setPredictedClosingDate] = useState("");
  const [Contact, setContact] = useState("");
  const [ContactID, setContactID] = useState("");
  const [ContactNo, setContactNo] = useState("");
  const [LeadSource, setLeadSource] = useState("");
  const [QuotationType, setQuotationType] = useState("");
  const [QuotationStage, setQuotationStage] = useState("");
  const [BillAddress, setBillAddress] = useState("");
  const [BillCountry, setBillCountry] = useState("");
  const [BillState, setBillState] = useState("");
  const [BillCity, setBillCity] = useState("");
  const [BillPINCode, setBillPINCode] = useState("");
  const [ShipAddress, setShipAddress] = useState("");
  const [isChecked, setIsChecked] = useState(false);
  const [ShipCity, setShipCity] = useState("");
  const [ShipPINCode, setShipPINCode] = useState("");
  const [ShipCountry, setShipCountry] = useState("");
  const [ShipState, setShipState] = useState("");
  const [CreatedBy, setCreatedBy] = useState("");
  const [TotalAmount, setTotalAmount] = useState("");
  const [Discount, setDiscount] = useState("");
  const [Email, setEmail] = useState("");
  const [NewDate, setNewDate] = useState("");
  const [CurDate, setCurDate] = useState("");
  const [EmailData, setEmailData] = useState([]);
  const [CloseQutData, setcloseQutData] = useState([]);
  const [EmailCount, setEmailCount] = useState(1);
  const [isOpenCloseQut, setisOpenCloseQut] = useState(false);
  const [isOpenConvert, setOpenConvert] = useState(false);
  const [isOpenDuplicateQtn, setOpenDuplicateQtn] = useState(false);
  const [DisableConvetbtn, setDisableConvetbtn] = useState(false);
  const [DisableClosebtn, setDisableClosebtn] = useState(false);
  const [DisableEditbtn, setDisableEditbtn] = useState(false);
  const [DisablePrintbtn, setDisablePrintbtn] = useState(false);
  const [DisableMailbtn, setDisableMailbtn] = useState(false);
  const [Response, fetchData] = UseFetchData();
  const [ResponseDupQtn, fetchDuplicateQtn] = UseFetchData();
  const [cmbPaymentTermsOptions, setcmbPaymentTermsOptions] = useState([]);
  const [cmbACAccount, setcmbACAccount] = useState([]);
  const [cmbLeadSourceData, setcmbLeadSourceData] = useState([]);
  const [cmbCountryData, setcmbCountryData] = useState([]);
  const [cmbCompanyData, setcmbCompanyData] = useState([]);
  const [ComboDataResponse, fetchComboData] = UseFetchData();
  const [NewQTID, setNewQTID] = useState(null);
  const [loading, setLoading] = useState(true);
  const [redirect, setRedirect] = useState(false);
  // const [isSOOpen, setSOOpen] = useState(false);
  const [CompanyID, setCompanyID] = useState();
  const linkRef = useRef(null);
  // const [pageName, setPageName] = useState("QuotationView")
  const history = useHistory();
  const location = useLocation();
  var status = location.state.Status;
  var Account = location.state.AccountName;
  var BCity = location.state.City;
  var Handelby = location.state.HandelBY;
  var PID = location.state.ProductID;
  var Mc = location.state.ModelNo;
  var Qno = location.state.QuotationNo;




  const handleOpenModal = () => {
    setOpen(true);
    SetQTID(QuotationID);
    setMode('Update');
  };

  const OpenModal = () => {
    setOpen(true);
    SetQTID("");
    setMode('Insert');
  };


  const handleOpenModals = () => {
    setAccountID('');
    var ToEmail = [];
    console.log(Email);
    ToEmail.push(Email);
    setEmailData(ToEmail);
    setMailOpen(true);
  }

  const handleOpencloseQutModal = () => {
    // debugger;
    setisOpenCloseQut(true);
    SetQTID(QuotationID);
    setQuotationLostReasonCodeID("")
    setMode('Insert');
  };

  useEffect(() => {
    GetComboData();
    // Session.set("QuotationID", QuotationID);

  }, []);


  // useEffect(() => {
  //   debugger;
  // }, []);


  const Openurl = async () => {
    //debugger;
    // QuotationID = QuotationID == undefined ? QuotationMainData[0].id : QuotationID;
      //
      axios.post('https://pmcrm.rpt.biztran.in/WebService.asmx/PrintReport', {
      //axios.post('http://localhost:49490/WebService.asmx/PrintReport', {
         // axios.post('http://localhost:801/webservice.asmx/printreport', {
      PKID: QuotationID,
      Type: 'Quotation'
    })
      .then(await function (response) {
        // debugger;
        console.log(response.data);
        setViewPath(response.data);
        window.open(response.data.d);
      })
      .catch(function (error) {
        alert('error to print')
        console.log(error);
      });
  }

  const GetComboData = () => {
    // setLoading(true);
    fetchComboData("Quotation/ComboDataHeaderView");
  };

  useEffect(() => {
    if (ComboDataResponse !== undefined) {
      setLoading(false);
      if (

        ComboDataResponse["LeadSource"] !== undefined &&
        ComboDataResponse["Country"] !== undefined &&
        // ComboDataResponse["ProductMake"] !== undefined &&
        ComboDataResponse["Company"] !== undefined &&
        ComboDataResponse["PaymentTerms"] !== undefined
        && ComboDataResponse["cmbAccount"] !== undefined
      ) {

        setcmbLeadSourceData(ComboDataResponse["LeadSource"]);
        setcmbCountryData(ComboDataResponse["Country"]);
        setcmbCompanyData(ComboDataResponse["Company"]);
        setcmbACAccount(ComboDataResponse['cmbAccount']);
        setcmbPaymentTermsOptions(ComboDataResponse['PaymentTerms']);

      }
    }
  }, [ComboDataResponse]);



  // //http://pmcrm.rpt.biztran.in/WebService.asmx/PrintReport
  // // http://localhost:49490/WebService.asmx/PrintReport
  // axios.post(REPORT_URL, {
  //   PKID: QuotationID,
  //   Type: 'Quotation'
  // })
  //   .then(function (response) {
  //     setViewPath(response.data);
  //   })
  //   .catch(function (error) {
  //     console.log(error);
  //   });

  const convertOpenModal = () => {
    setOpenConvert(true);
    // <Link to={{ pathname: "/SalesOrder/SalesOrderView" }} />
  }

  const duplicateOpenModal = () => {
    setOpenDuplicateQtn(true);
    // <Link to={{ pathname: "/SalesOrder/SalesOrderView" }} />
  }


  const ConvertToSO = async () => {
   
    if (ProductCount > 0) {
      setDisableConvetbtn(true);

      var bodyFormData = new FormData();
      if (QuotationID != undefined) {
        bodyFormData.append("QuotationID", QuotationID);

      } else {

        bodyFormData.append("QuotationID", QuotationMainData[0].id);
      }
      bodyFormData.append("CompanyID", QuotationMainData[0].CompanyID);
      bodyFormData.append("QuotationDate", QuotationDate);
      bodyFormData.append("ValidUpToDate", ValidUpToDate);
      // setLoading(true);
      await fetchData("Quotation/ConvertToSalesOrder", bodyFormData);
    }
    else {
      setOpenConvert(false);
      alert('Add Some Products.')
    }
  }

  const duplicateQtn = async () => {
    debugger;
    if (ProductCount > 0) {
      var bodyFormData = new FormData();
      if (QuotationID != undefined) {
        bodyFormData.append("QuotationID", QuotationID);

      } else {

        bodyFormData.append("QuotationID", QuotationMainData[0].id);
      }
      bodyFormData.append("CompanyID", QuotationMainData[0].CompanyID);
      bodyFormData.append("QuotationDate", QuotationDate);
      bodyFormData.append("ValidUpToDate", ValidUpToDate);
      // setLoading(true);
      await fetchDuplicateQtn("Quotation/DuplicateQtn", bodyFormData);
    }
    else {
      setOpenDuplicateQtn(false);
      alert('Add Some Products.')
    }
  }


  useEffect(() => {
    //debugger;
    if (QuotationMainData !== undefined && QuotationMainData.length > 0) {
      setPredictedClosingDate(QuotationMainData[0].PredictedClosingDate);
      setValidUpToDate(QuotationMainData[0].ValidUpTo);
      setCreatedBy(QuotationMainData[0].CreatedBy);
      setRevNo(QuotationMainData[0].RevNo);
      setGeneratedBy(QuotationMainData[0].GeneratedBy);
      setContactID(QuotationMainData[0].ContactID);
      setHandledBy(QuotationMainData[0].HandledBy);
      setCompany(QuotationMainData[0].CompanyCode);
      setAccountName(QuotationMainData[0].AccountName);
      setTotalAmount(QuotationMainData[0].TotalAmount);
      // setOpportunity(QuotationMainData[0].OpportunityNo);
      setQuotationNo(QuotationMainData[0].QuotationNo);
      setQuotationDate(QuotationMainData[0].QuotationDate);
      setLead(QuotationMainData[0].LeadNo);
      setEmail(QuotationMainData[0].Email === null ? "" : QuotationMainData[0].Email);
      setContact(QuotationMainData[0].ContactName);
      setContactNo(QuotationMainData[0].Mobile);
      setLeadSource(QuotationMainData[0].LeadSource);
      setQuotationType(QuotationMainData[0].QuotationType);
      setQuotationStage(QuotationMainData[0].QuotationStage);
      setBillAddress(QuotationMainData[0].BillAddress1 + " " + QuotationMainData[0].BillAddress2);
      setBillCity(QuotationMainData[0].BillCity === null ? "" : QuotationMainData[0].BillCity);
      setBillState(QuotationMainData[0].BillState === null ? "" : QuotationMainData[0].BillState);
      setBillCountry(QuotationMainData[0].BillCountry === null ? "" : QuotationMainData[0].BillCountry);
      setBillPINCode(QuotationMainData[0].BillPINCode === null ? "" : QuotationMainData[0].BillPINCode);
      setShipAddress(QuotationMainData[0].ShipAddress1 + " " + QuotationMainData[0].ShipAddress2);
      setShipCity(QuotationMainData[0].ShipCity === null ? "" : QuotationMainData[0].ShipCity);
      setShipState(QuotationMainData[0].ShipState === null ? "" : QuotationMainData[0].ShipState);
      setShipCountry(QuotationMainData[0].ShipCountry === null ? "" : QuotationMainData[0].ShipCountry);
      setShipPINCode(QuotationMainData[0].ShipPINCode === null ? "" : QuotationMainData[0].ShipPINCode);
      setQuotationLostRemarks(QuotationMainData[0].QuotationLostRemarks === null ? "" : QuotationMainData[0].QuotationLostRemarks);
      setQuotationLostWonBy(QuotationMainData[0].QuotationLostWonBy === null ? "" : QuotationMainData[0].QuotationLostWonBy);
      setQuotationLostUpdatedByID(QuotationMainData[0].QuotationLostUpdatedByID === null ? "" : QuotationMainData[0].QuotationLostUpdatedByID);
      if (QuotationMainData[0].QuotationStage === "SalesOrder") {
        setDisableConvetbtn(true);
      }
      else if (QuotationMainData[0].QuotationStage == "Closed") {
        setDisableClosebtn(true);
        setDisableEditbtn(true);
        setDisablePrintbtn(true);
        setDisableConvetbtn(true);
        setDisableMailbtn(true);
      }
    }
    // QuotationMainData[0].preventDefault();

  }, [QuotationMainData]);

  useEffect(() => {
    //debugger;
    if (ResponseDupQtn.Response === true) {
      alert('Quotation Replicated Successfully. Quotation Number: ' + ResponseDupQtn.ID);
      setOpenDuplicateQtn(false);
      var QuotationID = ResponseDupQtn.ID;
      //var QuotationID = '9D4FA0FB-E3F7-4814-9947-0000073C4E6D';
      setNewQTID(ResponseDupQtn.ID);
      // QuotationID = QuotationID == undefined ? QuotationMainData[0].id : QuotationID;
      history.push('/quotation', { QuotationID });
      //window.location.reload();
      //history.push('/quotation//QuotationView', { QuotationID });
      //window.location.reload();
      //const url = `/quotation/quotationView?QuotationID=${QuotationID}`;
      //window.open(url, '_blank');
      //history.push('/quotation/QuotationView', { QuotationID }); // navigate to new route
      //window.location.href = `/quotation/QuotationView?QuotationID=${QuotationID}`;
      // Response.preventDefault();
    }
    else if (ResponseDupQtn.Response === false) {
      alert('Error in Replicating Quotation.');
    }
  }, [ResponseDupQtn])


  useEffect(() => {
    //debugger;
    if (Response.Response === true) {
      alert('Sales Order Converted Successfully.');
      setOpenConvert(false);
      setDisableConvetbtn(true);
      var SalesOrderID = Response.ID;
      // QuotationID = QuotationID == undefined ? QuotationMainData[0].id : QuotationID;
      history.push('/SalesOrder/SalesOrderView', { SalesOrderID }); // navigate to new route
      // Response.preventDefault();
    }
    else if (Response.Response === false) {
      alert('Error in Convert Sales Order.');
    }
  }, [Response])



  return (
    < Paper elevation={3} >
      {/* loading && (
      <div style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        zIndex: 10,
      }}>
        <Loader />
      </div>
      ) */}
      <Typography className={classes.headertext} noWrap>
        <LocalAtmIcon style={{ fontSize: 36 }} />
        Quotation
        <div style={{ width: "70%" }}>
          <div style={{ float: "right", marginTop: -3 }}>
            {/* 10-feb - change */}
            <Grid container direction="row" >
              {/* <Grid item  >
                <Link
                  style={{ textDecoration: "none" }}
                  to={{
                    pathname: "/Quotation",
                    state: { status, Account, BCity, Handelby, PID, Mc, Qno },
                    // pageName: "header",
                  }}
                >
                  <BiztranControls.Button text={"Prev"} />
                </Link>
              </Grid> */}
              <Grid item  >
                <BiztranControls.Button
                  text="Print"
                  disabled={DisablePrintbtn}
                  onClick={() => {
                    Openurl();
                  }}
                />
              </Grid>
              <Grid item  >
                <BiztranControls.Button
                  text="EDIT"
                  disabled={DisableEditbtn}
                  startIcon={<EditIcon />}
                  onClick={() => {
                    handleOpenModal();
                  }} />
              </Grid>
              <Grid item >
                <BiztranControls.Button
                  text="Convert To SO"
                  disabled={DisableConvetbtn}
                  onClick={() => {
                    convertOpenModal();
                  }
                  }
                />
                {/* <div>
                  <Link to={{ pathname: "/SalesOrder/SalesOrderView", state: { QuotationID } }} style={{ fontSize: '20px' }} ></Link>
                </div> */}
              </Grid>
              <Grid item>
                <BiztranControls.Button
                  text="CloseQut"
                  disabled={DisableClosebtn}
                  onClick={() => {
                    handleOpencloseQutModal();
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={1} md={1} lg={1} xl={1} >
                <TextField id="outlined-basic" label="EmailID" variant="outlined" value={Email} style={{ width: '350px' }}
                  onChange={(e) => setEmail(e.target.value)} />

                <BiztranControls.Button
                  text="SendEmail"
                  startIcon={<AddCircleOutlineIcon />}
                  disabled={DisableMailbtn}
                  onClick={() => {
                    handleOpenModals();
                  }}
                />
                <BiztranControls.Button
                  text="Replicate"
                  //startIcon={<AddCircleOutlineIcon />}
                  disabled={DisableMailbtn}
                  onClick={() => {
                    duplicateOpenModal();
                  }}
                />
              </Grid>

            </Grid>
          </div>
        </div>

      </Typography>
      <Grid spacing={1} container style={{ marginTop: 7, paddingLeft: 10 }}>
        <Grid item xs={12} container direction="row">
          <Grid item xs={3} container direction="row">
            <h5 style={{ width: 100 }}>Quotation No:</h5>
            <h5 style={{ color: "#0096FF" }}>{QuotationNo + " - " + QuotationDate}</h5>
          </Grid>
          <Grid item xs={3} container direction="row">
            <h5 style={{ width: 110 }}>RevNo:</h5>
            <h5 style={{ color: "#0096FF" }}>{"R" + " - " + RevNo}</h5>
          </Grid>
          <Grid item xs={3} container direction="row">
            <h5 style={{ width: 100 }}>Company:</h5>
            <h5 style={{ color: "#0096FF" }}>{Company}</h5>
          </Grid>
          <Grid item xs={3} container direction="row">
            <h5 style={{ width: 110 }}>Status:</h5>
            <h5 style={{ color: "green" }}>{QuotationStage}</h5>
          </Grid>
        </Grid>
        <Grid item xs={12} container direction="row">
          <Grid item xs={3} container direction="row">
            <h5 style={{ width: 100 }}>Account Name:</h5>
            <h5 style={{ color: "#0096FF" }}>{AccountName}</h5>
          </Grid>
          <Grid item xs={3} container direction="row">
            <h5 style={{ width: 110 }}>Contact:</h5>
            <h5 style={{ color: "#0096FF" }}>{Contact}</h5>
          </Grid>
          <Grid item xs={3} container direction="row">
            <h5 style={{ width: 100 }}>Contact No:</h5>
            <h5 style={{ color: "#0096FF" }}>{ContactNo}</h5>
          </Grid>
          <Grid item xs={3} container direction="row">
            <h5 style={{ width: 140 }}>Valid UpTo Date:</h5>
            <h5 style={{ color: "#0096FF" }}>{ValidUpToDate}</h5>
          </Grid>
        </Grid>
        <Grid item xs={12} container direction="row">
          <Grid item xs={3} container direction="row">
            <h5 style={{ width: 100 }}>Generated By:</h5>
            <h5 style={{ color: "#0096FF" }}>{GeneratedBy}</h5>
          </Grid>
          <Grid item xs={3} container direction="row">
            <h5 style={{ width: 110 }}>Handled By:</h5>
            <h5 style={{ color: "#0096FF" }}>{HandledBy}</h5>
          </Grid>
          <Grid item xs={3} container direction="row">
            <h5 style={{ width: 100 }}>Lead Source:</h5>
            <h5 style={{ color: "#0096FF" }}>{LeadSource}</h5>
          </Grid>
          <Grid item xs={3} container direction="row">
            <h5 style={{ width: 140 }}>Predicted Closing Date:</h5>
            <h5 style={{ color: "#0096FF" }}>{PredictedClosingDate}</h5>
          </Grid>
        </Grid>
        <Grid item xs={12} container direction="row">
          <Grid item xs={3} container direction="row " >
            <h5 style={{ width: 100 }}>Billing Address:</h5>
            <h5 style={{ color: "#0096FF" }}>{BillAddress + " " + BillCity}</h5>
            <Grid item xs={3} container direction="row" >
              <h5 style={{ width: 100, color: "#0096FF" }}> {BillState + " " + BillCountry + " " + BillPINCode}</h5>
            </Grid>
          </Grid>
          <Grid item xs={3} container direction="row"  >
            <h5 style={{ width: 110 }}>Shipping Address:</h5>
            <h5 style={{ color: "#0096FF" }}>{ShipAddress + " " + ShipCity}</h5>
            <Grid item xs={3} container direction="row">
              <h5 style={{ width: 100, color: "#0096FF" }}> {ShipState + " " + ShipCountry + " " + ShipPINCode}</h5></Grid>
          </Grid>
          <Grid item xs={3} container direction="row">
            <h5 style={{ width: 140 }}>QuotationLost Remarks:</h5>
            <h5 style={{ color: "#0096FF" }}>{QuotationLostRemarks}</h5>
          </Grid>
          <Grid item xs={3} container direction="row">
            <h5 style={{ width: 140 }}>QuotationLost WonBy:</h5>
            <h5 style={{ color: "#0096FF" }}>{QuotationLostWonBy}</h5>
          </Grid>
        </Grid>
      </Grid>
      <ModalFrame
        title="Quotation Details"
        maxWidth="md"
        isOpen={isOpen}
        setOpen={setOpen}
      >
        <CreateQuotation
          QuotationID={QTID}
          setOpen={setOpen}
          QuotationMainData={QuotationMainData}
          Mode={Mode}
          PopulateData={PopulateData}
          cmbACAccount={cmbACAccount}
          cmbLeadSourceData={cmbLeadSourceData}
          cmbCountryData={cmbCountryData}
          cmbPaymentTermsOptions={cmbPaymentTermsOptions}
          cmbCompanyData={cmbCompanyData}
        />
      </ModalFrame>
      <ModalFrame
        title="SendEmail"
        maxWidth="md"
        isOpen={isMailOpen}
        headerAlign="center"
        setOpen={setMailOpen}
      >
        <SendEmail
          AccountID={AccountID}
          pageName={"Quotation"}
          ContactID={ContactID}
          setMailOpen={setMailOpen}
          EmailData={EmailData}
          EmailCount={1}
        />
      </ModalFrame>

      <ModalFrame
        title="CloseQut"
        maxWidth="sm"
        isOpen={isOpenCloseQut}
        headerAlign="center"
        setOpen={setisOpenCloseQut}
      >
        <CloseQut
          QuotationID={QTID}
          QuotationMainData={QuotationMainData}
          QuotationLostReasonCodeID={QuotationLostReasonCodeID}
          setisOpenCloseQut={setisOpenCloseQut}
          PopulateData={PopulateData}
          Mode={Mode}
        />
      </ModalFrame>
      <AlertDialog
        message="Do you want to convert to Sales Order?"
        isOpen={isOpenConvert}
        setOpenConvert={setOpenConvert}
      >
        <Grid spacing={2} container direction="row">
          <Grid item xs={12}>
            <div style={{ width: '100%' }}>
              <div style={{ display: 'flex', justifyContent: 'center', alignContent: "center" }}>

                {/* <Link
                  style={{ textDecoration: "none" }}
                  to={{
                    pathname: "/SalesOrder/SalesOrderView",
                    state: { QuotationID },
                  }}
                >
                  <BiztranControls.Button text={"Convert"} onClick={ConvertToSO} />
                </Link> */}
                <Link to={{ pathname: "/SalesOrder/SalesOrderView", state: { QuotationID } }}
                >
                </Link>


                <BiztranControls.Button
                  text="Convert"
                  startIcon={<SwapHorizIcon />}
                  onClick={ConvertToSO}
                />
                <BiztranControls.Button
                  text="Cancel"
                  onClick={() => { setOpenConvert(false); }}
                  startIcon={<CloseIcon />}
                />
              </div>
            </div>
          </Grid>
        </Grid>
      </AlertDialog>
      <AlertDialog
        message="Do you want to replicate the quotation?"
        isOpen={isOpenDuplicateQtn}
        setOpenDuplicateQtn={setOpenDuplicateQtn}
      >
        <Grid spacing={2} container direction="row">
          <Grid item xs={12}>
            <div style={{ width: '100%' }}>
              <div style={{ display: 'flex', justifyContent: 'center', alignContent: "center" }}>
                {/* <Link
            ref={linkRef}
            to={{
              pathname: '/quotation/QuotationView',
              state: { QuotationID: NewQTID }, // Handle default values if needed
            }}
            target="_blank" // Open link in new tab
            rel="noopener noreferrer" // Security measure for new tabs
            style={{
              textDecoration: 'none', // Remove underline
              color: '#007bff', // Custom link color (blue by default)
              fontWeight: 'bold', // Make it bold
              marginRight: '10px', // Add some margin for spacing
            }}
          >
            Go to Quotation View
          </Link> */}
                <BiztranControls.Button
                  text="Replicate"
                  startIcon={<SwapHorizIcon />}
                  onClick={duplicateQtn}
                />
                <BiztranControls.Button
                  text="Cancel"
                  onClick={() => { setOpenDuplicateQtn(false); }}
                  startIcon={<CloseIcon />}
                />
              </div>
            </div>
          </Grid>
        </Grid>
      </AlertDialog>
    </Paper >
  );
};

const useStyles = makeStyles((theme) => ({
  header: {
    width: "100%",
    background: "#e6d8d8", //theme.palette.tertiary.gradient,
    color: "#3d3d3d",
    height: "2.7rem",
    fontSize: "1.8rem",
    marginTop: "4.2rem",
    display: "flex",
    flexDirection: "row",
  },
  linkbutton: {
    display: "inline-block",
    padding: "8px 16px",
    fontsize: "16px",
    fontweight: "bold",
    color: "blue",
    backgroundcolor: "white",
    borderradius: "4px",
    textdecoration: "none",
  },
  headertext: {
    background: "#e6d8d8", //theme.palette.tertiary.gradient,
    color: "#3d3d3d",
    height: "2.7rem",
    fontSize: "1.8rem",
    marginTop: "4.3rem",
    display: "flex",
    flexDirection: "row",
  },
  headerCmn: {
    background: "#e6d8d8", //theme.palette.tertiary.gradient,
    color: "#3d3d3d",
    height: "2rem",
    fontSize: "1rem",
    display: "flex",
    flexDirection: "row",
    margin: "0.3rem",
    fontWeight: "bold",
  },
}));

export default withRouter(HeaderView);
